if (!customElements.get('vasenia-guide-purchase')) {
  customElements.define('vasenia-guide-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.native = this.querySelector('product-form');
      this.form = this.querySelector('form');
      this.button = this.querySelector('[type="submit"]');
      this.label = this.button.querySelector('span');
      this.initialLabel = this.dataset.addLabel;
      this.status = this.querySelector('[role="status"]');
      this.variant = this.form.elements.id.value;
      this.guard = this.onSubmit.bind(this);
      this.addEventListener('submit', this.guard, true);
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (event.source === 'product-form' && String(event.productVariantId) === this.variant) {
          this.confirmed = true;
          this.label.textContent = this.dataset.inCartLabel;
          this.showStatus(this.dataset.addedLabel);
        }
      });
      // The native form catches network failures without inline feedback. Observe
      // its completion so an ambiguous add always offers a cart review, not a retry.
      this.observer = new MutationObserver(() => {
        if (!this.nativePending || this.button.classList.contains('loading')) return;
        this.nativePending = false;
        if (!this.confirmed && this.querySelector('.product-form__error-message-wrapper').hidden) {
          this.showError(this.dataset.errorLabel);
        }
      });
      this.observer.observe(this.button, {attributes:true, attributeFilter:['class']});
    }
    disconnectedCallback() {
      this.removeEventListener('submit', this.guard, true);
      this.unsubscribe?.();
      this.observer?.disconnect();
      this.initialized = false;
    }
    showStatus(message) {
      this.status.textContent = message;
      this.status.hidden = false;
    }
    showError(message) {
      this.native.handleErrorMessage(message);
    }
    async onSubmit(event) {
      if (this.forwarding) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.checking || this.nativePending || this.button.getAttribute('aria-disabled') === 'true') return;
      this.checking = true;
      this.status.hidden = true;
      this.status.textContent = '';
      this.button.setAttribute('aria-disabled','true');
      this.native.handleErrorMessage();
      try {
        const response = await fetch(this.dataset.cartUrl + '.js', {headers:{Accept:'application/json'},cache:'no-store'});
        if (!response.ok) throw new Error('Cart check failed');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        if (cart.currency !== this.dataset.currency) {
          this.showError(this.dataset.currencyLabel);
          return;
        }
        if (cart.items.some(item => String(item.variant_id) === this.variant)) {
          this.label.textContent = this.dataset.inCartLabel;
          this.showStatus(this.dataset.alreadyLabel);
          window.location.assign(this.dataset.cartUrl);
          return;
        }
        this.label.textContent = this.initialLabel;
        this.confirmed = false;
        this.nativePending = true;
        this.button.removeAttribute('aria-disabled');
        this.forwarding = true;
        this.form.requestSubmit(this.button);
      } catch (error) {
        this.nativePending = false;
        this.showError(this.dataset.errorLabel);
      } finally {
        this.forwarding = false;
        this.checking = false;
        if (!this.nativePending) this.button.removeAttribute('aria-disabled');
      }
    }
  });
}
